import styled, { Scale, Typography } from '@secretescapes/falcon';
import { type CommonStyledProps } from '@utils/styles.utils';

export const Container = styled('div')<CommonStyledProps>`
  display: flex;
  flex-direction: column;
  ${({ isMobile }) => isMobile && `gap: ${Scale.xs}`};
  background-color: transparent;
  ${({ theme }) => `font-family: ${theme.fontFamilyBody.join(',')}`};
`;

export const CombinedH1 = styled('h1')<CommonStyledProps>`
  display: flex;
  flex-direction: column;
  ${({ isMobile }) => isMobile && `gap: ${Scale.xs}`};
  margin: 0;
  padding: 0;
`;

export const Title = styled(Typography)`
  order: 1;
`;

export const Subtitle = styled(Typography)`
  order: 2;
  cursor: pointer;
  text-decoration: underline;
`;
